
import { defineComponent } from 'vue'
import AsahiTypography from '@/components/library/Typography.vue'

export default defineComponent({
  name: 'LoginErrorModal',
  components: {
    AsahiTypography
  },
  props: {
    message: String,
    closeModal: {
      type: Function,
      default: () => {
        /* */
      }
    }
  }
})
